import { render } from "./HomeSection.vue?vue&type=template&id=56007cda&ts=true"
import script from "./HomeSection.vue?vue&type=script&lang=ts"
export * from "./HomeSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__